import {fromJS, List} from 'immutable';
import * as actionTypes from '../actions/thesaurusActionTypes';
import { getKeyPath } from '../utils/immutableUtils';
import * as categoriesActionTypes from "../actions/categoriesActionTypes";

const initialState = fromJS({
  termsList: [],
  isRetrievingRoot: false,
  rootRequest: null,
  deleteRequests: {},
  editRequests: {},
  createRequests: [],
  retrieveChildrenRequests: {},
});

const createSetData = (id, name, thesId) => (fromJS({
  n: name,
  ID: id,
  TOT: '',
  THES_ID: thesId,
  ch: 'TRUE',
  u: '',
  ct: [],
  xpnd: false,
}));

const thesaurus = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TERM_RETRIEVE_REQUEST:
      /*      if (action.termID) {
              // request is for a child category, not root
              if (state.getIn(['retrieveChildrenRequests', action.termID]) &&
                !(state.getIn(['retrieveChildrenRequests', action.termID]) instanceof Error)) {
                // request already exists for this so cancel the current one
                state.getIn(['retrieveChildrenRequests', action.termID]).cancel();
              }

              return state.mergeDeep(fromJS({
                retrieveChildrenRequests: { [action.termID]: action.requestPromise } }));
            } else if (state.get('rootRequest')) {
              // cancel the current root request promise since it exists
              state.get('rootRequest').cancel();
            }*/

      return state
        .set('isRetrievingRoot', true)
        .set('rootRequest', action.requestPromise)
        ;
    case actionTypes.TERM_RETRIEVE_SUCCESS:
    {
      if (action.parentID) {
        // request is for a child category, not root
        let newCategoryList;
        const retrieveChildrenRequests = state.get('retrieveChildrenRequests')
          .delete(action.parentID);
        const foundPath = getKeyPath(state.get('termsList'), 'i', action.parentID, 'ct');

        if (foundPath) {
          newCategoryList = state
            .get('termsList')
            .setIn([...foundPath, 'ct'], fromJS(action.termsList))
            .setIn([...foundPath, 'xpnd'], true);
        }

        return state
          .set('termsList', newCategoryList || state.get('termsList'))
          .set('retrieveChildrenRequests', retrieveChildrenRequests)
          ;
      }

      return state
        .set('isRetrievingRoot', false)
        .set('rootRequest', null)
        .set('termsList', fromJS(action.termsList))
        .set('retrieveChildrenRequests', fromJS({}))
        ;
    }
    case actionTypes.TERM_RETRIEVE_FAILURE:
      return state
        .set('isRetrievingRoot', false)
        .set('rootRequest', action.err)
        ;
    case actionTypes.TERM_CREATE_REQUEST: {
      const foundRequestIndex = state.get('createRequests').findKey(createRequest =>
        createRequest.get('workspaceName') === action.workspaceName &&
        createRequest.get('workspaceParentID') === action.workspaceParentID
      );

      if (foundRequestIndex !== undefined) {
        // request with same details already exist, so just overwrite that one
        return state
          .setIn(['createRequests', foundRequestIndex, 'request'], action.requestPromise)
          .setIn(['createRequests', foundRequestIndex, 'workspaceDescription'],
            action.workspaceDescription)
          ;
      }

      return state.set('createRequests', state.get('createRequests').push(fromJS({
        workspaceName: action.workspaceName,
        workspaceParentID: action.workspaceParentID,
        workspaceDescription: action.workspaceDescription,
        request: action.requestPromise,
      })));
    }
    case actionTypes.TERM_CREATE_SUCCESS: {
      const foundRequestIndex = state.get('createRequests').findKey(createRequest =>
        createRequest.get('workspaceName') === action.workspaceName &&
        createRequest.get('workspaceParentID') === action.workspaceParentID
      );

      let newState = state;

      if (foundRequestIndex !== undefined) {
        const newState = state.deleteIn(['createRequests', foundRequestIndex]);
      }

      if (action.workspaceParentID && action.workspaceID !== '0') {
              const foundKeyPath = getKeyPath(state.get('termsList'), 'i', action.workspaceParentID, 'ct');

        // adds new term to a non-root level term
        if (foundKeyPath) {
          let newChildList = newState.getIn(['termsList', ...foundKeyPath, 'ct']);

          if (newChildList) {
            newChildList = newChildList.push(createSetData(
              action.workspaceID,
              action.workspaceName,
            ));
          } else {
            newChildList = new List([createSetData(
              action.workspaceID,
              action.workspaceName,
            )]);
          }

          return newState
            .setIn(['termsList', ...foundKeyPath, 'ch'], 'TRUE')
            .setIn(['termsList', ...foundKeyPath, 'ct'], newChildList);
        }
        return newState;
      }

        // adds new workspace to root level workspace
        return newState.set('termsList', state.get('termsList')
          .push(createSetData(
            action.workspaceID,
            action.workspaceName,
          )));
      }
    case actionTypes.TERM_CREATE_FAILURE: {
      const foundRequestIndex = state.get('createRequests').findKey(createRequest =>
        createRequest.get('workspaceName') === action.workspaceName &&
        createRequest.get('workspaceParentID') === action.workspaceParentID
      );

      if (foundRequestIndex !== undefined) {
        return state.setIn(['createRequests', foundRequestIndex, 'request'], action.err);
      }

      return state;
    }
    case actionTypes.TERM_EDIT_REQUEST:
      return state.setIn(['editRequests', action.workspaceID], fromJS({
        workspaceName: action.workspaceName,
        workspaceDescription: action.workspaceDescription,
        request: action.requestPromise,
      }));
    case actionTypes.TERM_EDIT_SUCCESS:
      if (state.getIn(['editRequests', action.workspaceID])) {
        let newState = state.deleteIn(['editRequests', action.workspaceID]);

        if (action.workspaceName || action.workspaceDescription) {
          const foundPath = getKeyPath(state.get('termsList'), 'i', action.workspaceID, 'ct');
          if (foundPath) {
            if (action.workspaceName) {
              newState = newState.setIn(['termsList', ...foundPath, 'n'], action.workspaceName);
            }
          }
        }

        return newState;
      }
      return state;
    case actionTypes.TERM_EDIT_FAILURE:
      return state.setIn(['editRequests', action.workspaceID, 'request'], action.err);
    case actionTypes.TERM_DELETE_REQUEST: {
      const foundPath = getKeyPath(state.get('termsList'), 'i', action.workspaceID, 'ct');
      if (foundPath) {
        const workspaceData = state.getIn(['termsList', ...foundPath]);
        return state.setIn(['deleteRequests', action.workspaceID], fromJS({
          workspaceName: workspaceData.get('n'),
          workspaceDescription: workspaceData.get('d'),
          request: action.requestPromise,
        }));
      }

      return state;
    }
    case actionTypes.TERM_DELETE_SUCCESS: {
      const foundPath = getKeyPath(state.get('termsList'), 'i', action.workspaceID, 'ct');
      return state
        .deleteIn(['deleteRequests', action.workspaceID])
        .deleteIn(['termsList', ...foundPath])
        ;
    }
    case actionTypes.TERM_DELETE_FAILURE:
      return state.setIn(['deleteRequests', action.workspaceID, 'request'], action.err);
    case actionTypes.THES_CANCEL_ALL_REQUESTS:
      state.get('retrieveChildrenRequests').find((value) => {
        if (value.cancel) {
          value.cancel();
        }
        return false;
      });

      if (state.get('rootRequest') && state.get('rootRequest').cancel) {
        state.get('rootRequest').cancel();
      }

      return state
        .set('isRetrievingRoot', false)
        .set('rootRequest', null)
        .set('retrieveChildrenRequests', fromJS({}))
        ;
    case actionTypes.THES_COLLAPSE:
      return state.setIn(['deleteRequests', action.categoryID, 'request'], action.err);
    case actionTypes.THES_LIST_CLEAR: {
      let newCategoryList = state.get('termsList');
      const foundPath = getKeyPath(state.get('termsList'), 'i', action.categoryID, 'ct');

      if (foundPath) {
        newCategoryList = state
          .get('termsList')
          .setIn([...foundPath, 'ct'], new List())
          .setIn([...foundPath, 'xpnd'], false);
      }
      return state
        .set('termsList', newCategoryList)
        ;
    }
    default:
      return state;
  }
};

export default thesaurus;
